<!--
 * @Description: 
 * @Autor: jyf
 * @Date: 2021-06-29 14:36:24
 * @LastEditors: yinwenxuan yinwenxuan@vip56.cn
 * @LastEditTime: 2024-11-14 15:36:00
-->

<template>
<div class="n_box">
	
	<van-popover
	v-model="showPopover"
	trigger="click"
	:placement="placement"
	>
	<div class="key-board" >
	
		  <div class="keys">
			  <div class="key_l">
				  <div class="key button" v-for="num in config.loop" :key="num.key" @click.stop="number(num.number)">{{num.number}}</div>
					<div class="key button" @click.stop="clearFun">清空</div>
					<div class="key button" @click.stop="number(0)">0</div>
					<div class="key button"  v-if="isNeedDot" @click.stop="number('.')">.</div>
					<div class="key button" @click.stop="del" v-else>
					  <img src="@/assets/padImg/p_delete.png" style="width: 2.12vw;height: 1.76vw;" alt="">
				  </div>
			  </div>
			  <div class="key_r">
				  <div class="key button" @click.stop="del" v-if="isNeedDot">
					  <img src="@/assets/padImg/p_delete.png" style="width: 2.12vw;height: 1.76vw;" alt="">
				  </div>
				  <div class="key button key2" @click="collaspeFun" :style="isNeedDot?'height:17.94vw;':'height:24.09vw'">
					  <img src="@/assets/padImg/c_up.png" style="width: 3.22vw;height: 3.22vw;" alt="">
				  </div>

			  </div>
		  </div>
	</div>  
	<template #reference>
			<input class="pi_input pi_number" v-model="value" type="text" :placeholder="placeholder" readonly :style="styleStr">
			
		</template>
		</van-popover>
</div>
</template>


<script>
export default {
  props: {
		isNeedDot: {
			type: Boolean,
			default: true
		},
		maxLength: {
			type: Number,
			default: 10
		},
		defaultVal: {
			type: Number | String,
			default: null
		},
		placement: {
			type: String,
			default: 'bottom'
		},
		width: {
			type: String,
			default: '24.89vw'
		},
		height: {
			type: String,
			default: '3.37vw'
		},
		styleStr: {
			type: String,
			default: 'width:27.82vw;height:4.39vw;'
		},
		placeholder: {
			type: String,
			default: '请输入'
		},
		
	},
  data() {
    return {
	  value:null,
	  showPopover:false,
      config :{
				loop : [
					{
						number : 1,
						key : 'number-1',
					},
					{
						number : 2,
						key : 'number-2',
					},
					{
						number : 3,
						key : 'number-3',
					},
					{
						number : 4,
						key : 'number-4',
					},
					{
						number : 5,
						key : 'number-5',
					},
					{
						number : 6,
						key : 'number-6',
					},
					{
						number : 7,
						key : 'number-7',
					},
					{
						number : 8,
						key : 'number-8',
					},
					{
						number : 9,
						key : 'number-9',
					},
				]
			},

    };
  },
  watch: {
		defaultVal: function(value, oldValue) {
			this.value = value;
		}
		
	},

  methods: {
    close(){
		this.showKeyBoard = false;
		this.$emit("close");
	},
	del() {
		let index = this.value.length;
		if(index==0) return;
        this.value = this.value.toString().slice(0,index-1);
		this.finishFun();
	},
	number(number) {
		// this.$emit("number", number);
		let val = this.value;
		let dotIndex = this.value?this.value.toString().indexOf('.'):-1;
		if(number=='.'&&dotIndex>-1||this.value&&this.value.toString().length==this.maxLength) return;
		this.value = this.value?this.value.toString() + number.toString():number.toString();
		if(dotIndex>-1){
			if(val.toString().slice(dotIndex+1).length>1){
				this.value = this.value.slice(0,dotIndex+3)
			}
		}else{
			this.value = this.value.slice(0,this.maxLength)
		}
		this.finishFun();
	},
	collaspeFun(){
		this.showPopover = false;
	},
	finishFun(){
	this.$emit('finishFun',this.value);
	},
	clearFun(){
		this.value = null;
		this.finishFun();
}

  },
  onLoad() {
  },
  onShow() {},
  mounted() {
    this.value = this.defaultVal;

  }

};
</script>

<style lang="scss" scoped>
.pi_input{
	width: 27.82vw;
    height: 4.39vw;
	border: 1PX solid #D8DCE5;
	border-radius: 0.29vw;
	font-size: 1.32vw;
	padding-left: 1.24vw;
	box-sizing: border-box;
}
.key-board {
	width: 30.38vw;
	height: 25.99vw;
	background: #ffffff;
	box-shadow: 0px 0.29vw 0.73vw 0px rgba(0, 0, 0, 0.3);
	box-sizing: border-box;
	padding: 0.5vw;

	.title {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 8vw;
		background: #eeeeee;
	}
	.keys {
		display: flex;
		width: 100%;
		.key_l{
			display: flex;
			flex-wrap: wrap;
			width: max-content;
			.key{
				margin-right: 0.51vw;
				margin-bottom: 0.73vw;
				:nth-child(3n){
					margin-right: 0;
				}
			}
		}
		.key_r{
			width: 30.38vw;
			.key{
				margin-bottom: 0.73vw;
			}
			.key2{
				height: 17.94vw;
			}
		}
		.key {
			width: 6.73vw;
			height: 5.42vw;
			display: flex;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;
			font-size: 5.33vw;
			color: #1A1A1A;
			background: #ffffff;
			font-size: 2.2vw;
			font-weight: bold;
			line-height: 5.42vw;
			text-align: center;
			letter-spacing: 0px;
			color: #4E5969;
			border: 1PX solid #D8DCE5;
			box-shadow: 0px 0.29vw 0px 0px rgba(0, 0, 0, 0.2);
			border-radius: 0.29vw;
		}
		
	}
	
}

</style>


// WEBPACK FOOTER //
// src/components/pad/NumberKeyboard.vue